<div class="component checkbox-example">
    <h2>Checkbox</h2>
    <div class="example">
        <sbw-checkbox (changed)="checkboxChanged($event, null)">Checkbox with changed event</sbw-checkbox>
    </div>
    <div class="example">
        <sbw-checkbox [id]="'demoCheckbox'">Checkbox with id</sbw-checkbox>
    </div>
    <div class="example">
        <sbw-checkbox [checked]="true" (changed)="checkboxChanged($event, null)">Checkbox that is selected by default</sbw-checkbox>
    </div>
    <div class="example">
        <sbw-checkbox [checked]="true" [disabled]="true">Checkbox that is disabled</sbw-checkbox>
    </div>
    <div class="example">
        <sbw-checkbox [checked]="true" [readonly]="true">Checkbox that is readonly</sbw-checkbox>
    </div>
    <div class="example">
        <p>
            How to determine which checkbox that triggered the event when output in loop
        </p>
        <div *ngFor="let checkbox of checkboxes">
            <sbw-checkbox [id]="checkbox.id" [checked]="checkbox.checked" (changed)="checkboxChanged($event, checkbox)">Checkbox: {{checkbox.id}}</sbw-checkbox>
        </div>
    </div>
</div>